export default function () {
  const widgetName = 'diamondSponsors';
  const widgetOpts = diamondSponsorsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customStyle() {
        $(`#${widgetName} .card-widget-item`).each(function (x) {

          $(this).removeAttr('target');
          $(this).find('.card-content').remove();
          $(this).attr('title', (slide.items[x].Title))
          if ($(this).attr('class') == "card-widget-item void-link") {
            $(this).removeAttr('href');
          }
        })
      }
      customStyle()
      $('#diamondSponsors').before('<span class="diamond-title">Diamond Sponsors</span>')

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'Learn more'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}